/*!
==========================================================
DH Commerce Framework
Version: 1.2.0
Author: OpenAI + DH Foods

This file is the global commerce framework.

It intentionally DOES NOT replace the existing homepage
JavaScript yet.

Instead it provides:

• Shared Commerce State
• Event Bus
• Analytics
• Shipping Intelligence
• Promotion Engine (placeholder)
• Dashboard Hooks

Existing homepage code will gradually migrate into this
framework over the next development sprints.

==========================================================
*/

(function (window, document) {

  "use strict";

  /*
Allow this version to replace an older DH Commerce framework.
Prevent only the same version from initializing twice.
*/

if (
  window.DHCommerce &&
  window.DHCommerce.version === "1.2.0"
) {
  return;
}

const DHCommerce = {};

  /* ======================================================
     VERSION
  ====================================================== */

  DHCommerce.version = "1.2.0";

  /* ======================================================
     CONFIGURATION
  ====================================================== */

  DHCommerce.config = {

    shipping: {

      unknownBehavior: "far",

      near: {
        freeShippingThreshold: 59,
        giftThreshold: 69
      },

      middle: {
        freeShippingThreshold: 79,
        giftThreshold: 89
      },

      far: {
        freeShippingThreshold: 99,
        giftThreshold: 109
      }

    },

    promotions: {

      activePromotionId: "weekend_shipping_test",

      library: {

        weekend_shipping_test: {

          id: "weekend_shipping_test",

          active: true,

          priority: 100,

          type: "shipping_and_gift",

          name: "Weekend Shipping Test",

          startsAt: null,

          endsAt: null,

          tiers: {

            near: {

              enabled: true,

              eyebrow: "Local Advantage",

              headline: "Fresh Desserts. Better Shipping.",

              message:
                "You are close to our Tennessee kitchen, so your order qualifies for our best shipping value.",

              offerLabel: "Free shipping at $59",

              freeShippingThreshold: 59,

              giftThreshold: 69,

              giftName: "Special Weekend Gift",

              ctaLabel: "Shop Desserts"

            },

            middle: {

              enabled: true,

              eyebrow: "Regional Delivery",

              headline: "Fast Regional Shipping.",

              message:
                "Build an assortment that gives you more dessert value from every shipment.",

              offerLabel: "Free shipping at $79",

              freeShippingThreshold: 79,

              giftThreshold: 89,

              giftName: "Special Weekend Gift",

              ctaLabel: "Build Your Assortment"

            },

            far: {

              enabled: true,

              eyebrow: "Nationwide Shipping",

              headline: "More Dessert. Better Shipping Value.",

              message:
                "Larger assortments make nationwide cold shipping work harder for you.",

              offerLabel: "Free shipping at $99",

              freeShippingThreshold: 99,

              giftThreshold: 109,

              giftName: "Special Weekend Gift",

              ctaLabel: "Build A Larger Assortment"

            }

          }

        }

      }

    },

    analytics: {

      enabled: true,

      debug: true

    }

  };

  /* ======================================================
     GLOBAL STATE
  ====================================================== */

  DHCommerce.state = {

    initialized: false,

    session: {

      id:
        window.crypto &&
        window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : Date.now().toString(36) +
            Math.random().toString(36).substring(2)

    },

    customer: {

      returning: false,

      emailKnown: false

    },

    shipping: {

  /*
  The actual detected value:

  near
  middle
  far
  unknown
  */

  tier: "unknown",

  /*
  Unknown visitors are treated like Far for commerce
  recommendations until a destination is known.
  */

  effectiveTier: "far",

  source: "default",

  confidence: "unknown",

  location: {
    country: "",
    state: "",
    city: "",
    zip: ""
  },

  initialized: false

},

    journey: {

      preference: null,

      category: null,

      product: null,

      pack: null

    },

    assortment: {

      selections: [],

      subtotal: 0,

      count: 0

    },

    promotions: {

      active: [],

      giftUnlocked: false,

      freeShippingUnlocked: false

    },

    analytics: {

      events: []

    }

  };

  /* ======================================================
     EVENT BUS
  ====================================================== */

  DHCommerce.emit = function (eventName, payload) {

    payload = payload || {};

    const event = {

      name: eventName,

      payload: payload,

      timestamp: Date.now()

    };

    DHCommerce.state.analytics.events.push(event);

    document.dispatchEvent(
      new CustomEvent("dhcommerce", {
        detail: event
      })
    );

    if (DHCommerce.config.analytics.debug) {

      console.log(

        "%cDH Commerce",

        "color:#c89c3d;font-weight:bold",

        event

      );

    }

    return event;

  };

  /*
  Supports both formats:

  DHCommerce.on(function (event) {});
  
  DHCommerce.on("shipping:ready", function (event) {});
  */

  DHCommerce.on = function (eventName, callback) {

    if (typeof eventName === "function") {

      callback = eventName;

      eventName = null;

    }

    if (typeof callback !== "function") {

      return function () {};

    }

    const listener = function (event) {

      const commerceEvent = event.detail;

      if (
        eventName &&
        commerceEvent.name !== eventName
      ) {

        return;

      }

      callback(commerceEvent);

    };

    document.addEventListener(
      "dhcommerce",
      listener
    );

    /*
    Returns an unsubscribe function for future engines.
    */

    return function () {

      document.removeEventListener(
        "dhcommerce",
        listener
      );

    };

  };

/* ======================================================
   EVENT BUS COMPATIBILITY API
====================================================== */

DHCommerce.events = {

  emit: function (eventName, payload) {
    return DHCommerce.emit(
      eventName,
      payload || {}
    );
  },

  on: function (eventName, callback) {
    return DHCommerce.on(
      eventName,
      callback
    );
  }

};

  /* ======================================================
     ANALYTICS
  ====================================================== */

  DHCommerce.analytics = {};

  DHCommerce.analytics.track = function (name, payload) {

    if (!DHCommerce.config.analytics.enabled) {

      return null;

    }

    return DHCommerce.emit(name, payload);

  };

  /* ======================================================
     SHIPPING INTELLIGENCE
  ====================================================== */

  DHCommerce.shipping = {};

  DHCommerce.shipping.validTiers = [
    "near",
    "middle",
    "far",
    "unknown"
  ];

/*
  Reads the location and regional-rule data that the
  Shopify section placed on window.DHCommerceBootstrap.
*/

DHCommerce.shipping.getBootstrap = function () {
  return (
    window.DHCommerceBootstrap &&
    typeof window.DHCommerceBootstrap === "object"
  )
    ? window.DHCommerceBootstrap
    : {};
};


/*
  Converts comma-separated state codes such as:

  TN, KY, AL

  into:

  ["TN", "KY", "AL"]
*/

DHCommerce.shipping.parseStateList = function (value) {
  if (Array.isArray(value)) {
    return value
      .map(function (state) {
        return String(state || "")
          .trim()
          .toUpperCase();
      })
      .filter(Boolean);
  }

  return String(value || "")
    .split(",")
    .map(function (state) {
      return state
        .trim()
        .toUpperCase();
    })
    .filter(Boolean);
};


/*
  Returns the regional rules configured in the Shopify
  Theme Editor.
*/

DHCommerce.shipping.getRegionalRules = function () {
  const bootstrap =
    DHCommerce.shipping.getBootstrap();

  const rules =
    bootstrap.regionalRules &&
    typeof bootstrap.regionalRules === "object"
      ? bootstrap.regionalRules
      : {};

  return {
    active: rules.active !== false,

    key:
      String(rules.key || "us_standard")
        .trim(),

    nearStates:
      DHCommerce.shipping.parseStateList(
        rules.nearStates
      ),

    middleStates:
      DHCommerce.shipping.parseStateList(
        rules.middleStates
      ),

    farStates:
      DHCommerce.shipping.parseStateList(
        rules.farStates
      ),

    excludedRegions:
      DHCommerce.shipping.parseStateList(
        rules.excludedRegions
      ),

    defaultTier:
      DHCommerce.shipping.normalizeTier
        ? DHCommerce.shipping.normalizeTier(
            rules.defaultTier || "far"
          )
        : String(
            rules.defaultTier || "far"
          ).toLowerCase()
  };
};


/*
  Resolves a two-letter state code against the Theme
  Editor's Near, Middle, and Far lists.
*/

DHCommerce.shipping.resolveTierFromState = function (
  stateCode
) {
  const state =
    String(stateCode || "")
      .trim()
      .toUpperCase();

  const rules =
    DHCommerce.shipping.getRegionalRules();

  if (!state || rules.active === false) {
    return {
      tier: rules.defaultTier || "far",
      matched: false,
      excluded: false,
      state: state || null
    };
  }

  if (rules.excludedRegions.includes(state)) {
    return {
      tier: rules.defaultTier || "far",
      matched: false,
      excluded: true,
      state: state
    };
  }

  if (rules.nearStates.includes(state)) {
    return {
      tier: "near",
      matched: true,
      excluded: false,
      state: state
    };
  }

  if (rules.middleStates.includes(state)) {
    return {
      tier: "middle",
      matched: true,
      excluded: false,
      state: state
    };
  }

  if (rules.farStates.includes(state)) {
    return {
      tier: "far",
      matched: true,
      excluded: false,
      state: state
    };
  }

  return {
    tier: rules.defaultTier || "far",
    matched: false,
    excluded: false,
    state: state
  };
};

  DHCommerce.shipping.isValidTier = function (tier) {

    return (
      DHCommerce.shipping.validTiers.indexOf(tier) !== -1
    );

  };

  DHCommerce.shipping.normalizeTier = function (tier) {

    if (typeof tier !== "string") {

      return "unknown";

    }

    tier = tier
      .trim()
      .toLowerCase();

    return DHCommerce.shipping.isValidTier(tier)
      ? tier
      : "unknown";

  };

  DHCommerce.shipping.getEffectiveTier = function (tier) {

    tier = DHCommerce.shipping.normalizeTier(
      tier || DHCommerce.state.shipping.tier
    );

    if (tier === "unknown") {

      return DHCommerce.config.shipping.unknownBehavior || "far";

    }

    return tier;

  };

  DHCommerce.shipping.getRules = function (tier) {

    const effectiveTier =
      DHCommerce.shipping.getEffectiveTier(tier);

    return (
      DHCommerce.config.shipping[effectiveTier] ||
      DHCommerce.config.shipping.far
    );

  };

  DHCommerce.shipping.saveSessionTier = function (tier) {

    try {

      window.sessionStorage.setItem(
        "dhcommerce_shipping_tier",
        tier
      );

    } catch (error) {

      /*
      Storage may be unavailable in private browsing or
      restricted browser environments. Shipping still works.
      */

    }

  };

  DHCommerce.shipping.getSessionTier = function () {

    try {

      const tier =
        window.sessionStorage.getItem(
          "dhcommerce_shipping_tier"
        );

      return DHCommerce.shipping.isValidTier(tier)
        ? tier
        : null;

    } catch (error) {

      return null;

    }

  };

/*
  Persistent regional-location cache.

  Six hours keeps repeat visits fast while allowing
  travelers to be re-resolved later the same day.
*/

DHCommerce.shipping.locationCacheKey =
  "dhcommerce_shipping_location_v1";

DHCommerce.shipping.locationCacheLifetime =
  6 * 60 * 60 * 1000;


DHCommerce.shipping.saveLocationCache = function (
  tier,
  location
) {
  try {
    window.localStorage.setItem(
      DHCommerce.shipping.locationCacheKey,
      JSON.stringify({
        tier:
          DHCommerce.shipping.normalizeTier(tier),

        location: {
          country:
            String(
              location && location.country || ""
            )
              .trim()
              .toUpperCase(),

          state:
            String(
              location && location.state || ""
            )
              .trim()
              .toUpperCase(),

          city:
            String(
              location && location.city || ""
            ).trim(),

          zip:
            String(
              location && location.zip || ""
            ).trim()
        },

        savedAt: Date.now()
      })
    );
  } catch (error) {
    /*
      The storefront continues normally when local
      storage is unavailable.
    */
  }
};


DHCommerce.shipping.getLocationCache = function () {
  try {
    const rawValue =
      window.localStorage.getItem(
        DHCommerce.shipping.locationCacheKey
      );

    if (!rawValue) {
      return null;
    }

    const cached = JSON.parse(rawValue);

    if (
      !cached ||
      !cached.savedAt ||
      Date.now() - Number(cached.savedAt) >
        DHCommerce.shipping.locationCacheLifetime
    ) {
      window.localStorage.removeItem(
        DHCommerce.shipping.locationCacheKey
      );

      return null;
    }

    const tier =
      DHCommerce.shipping.normalizeTier(
        cached.tier
      );

    if (
      tier === "unknown" ||
      !cached.location ||
      !cached.location.state
    ) {
      return null;
    }

    return {
      tier: tier,

      location: {
        country:
          String(
            cached.location.country || ""
          )
            .trim()
            .toUpperCase(),

        state:
          String(
            cached.location.state || ""
          )
            .trim()
            .toUpperCase(),

        city:
          String(
            cached.location.city || ""
          ).trim(),

        zip:
          String(
            cached.location.zip || ""
          ).trim()
      },

      savedAt: Number(cached.savedAt)
    };
  } catch (error) {
    return null;
  }
};


DHCommerce.shipping.setLocation = function (
  location
) {
  location = location || {};

  DHCommerce.state.shipping.location = {
    country:
      String(location.country || "")
        .trim()
        .toUpperCase(),

    state:
      String(location.state || "")
        .trim()
        .toUpperCase(),

    city:
      String(location.city || "")
        .trim(),

    zip:
      String(location.zip || "")
        .trim()
  };

  return DHCommerce.state.shipping.location;
};

  DHCommerce.shipping.getPreviewOverride = function () {

    try {

      const parameters =
        new URLSearchParams(window.location.search);

      const tier =
        parameters.get("dh_shipping");

      if (!tier) {

        return null;

      }

      const normalizedTier =
        DHCommerce.shipping.normalizeTier(tier);

      return DHCommerce.shipping.isValidTier(
        normalizedTier
      )
        ? normalizedTier
        : null;

    } catch (error) {

      return null;

    }

  };

  DHCommerce.shipping.setTier = function (
    tier,
    options
  ) {

    options = options || {};

    const normalizedTier =
      DHCommerce.shipping.normalizeTier(tier);

    const effectiveTier =
      DHCommerce.shipping.getEffectiveTier(
        normalizedTier
      );

    DHCommerce.state.shipping.tier =
      normalizedTier;

    DHCommerce.state.shipping.effectiveTier =
      effectiveTier;

    DHCommerce.state.shipping.source =
      options.source || "manual";

    DHCommerce.state.shipping.confidence =
      options.confidence || "unknown";

    if (options.persist !== false) {

      DHCommerce.shipping.saveSessionTier(
        normalizedTier
      );

    }

    const payload = {

      tier: normalizedTier,

      effectiveTier: effectiveTier,

      source:
        DHCommerce.state.shipping.source,

      confidence:
        DHCommerce.state.shipping.confidence,

      rules:
        DHCommerce.shipping.getRules(
          normalizedTier
        )

    };

    DHCommerce.emit(
      "shipping:tier",
      payload
    );

    return payload;

  };

/*
  Reads a logged-in Shopify customer's location from
  the homepage bootstrap data.
*/

DHCommerce.shipping.getCustomerLocation = function () {
  const bootstrap =
    DHCommerce.shipping.getBootstrap();

  const location =
    bootstrap.customerLocation &&
    typeof bootstrap.customerLocation === "object"
      ? bootstrap.customerLocation
      : {};

  return {
    loggedIn: location.loggedIn === true,

    country:
      String(location.country || "")
        .trim()
        .toUpperCase(),

    state:
      String(location.state || "")
        .trim()
        .toUpperCase(),

    city:
      String(location.city || "")
        .trim(),

    zip:
      String(location.zip || "")
        .trim()
  };
};

/*
  Attempts to determine an anonymous visitor's state
  through an approximate IP-location lookup.

  This does not request browser GPS permission and never
  blocks the storefront if the service is unavailable.
*/

DHCommerce.shipping.getAnonymousLocation = function () {
  const controller =
    typeof AbortController !== "undefined"
      ? new AbortController()
      : null;

  const timeoutId = window.setTimeout(function () {
    if (controller) {
      controller.abort();
    }
  }, 2500);

  return fetch("https://ipapi.co/json/", {
    method: "GET",
    headers: {
      Accept: "application/json"
    },
    signal: controller
      ? controller.signal
      : undefined
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          "Anonymous location lookup failed."
        );
      }

      return response.json();
    })
    .then(function (location) {
      window.clearTimeout(timeoutId);

      return {
        country:
          String(
            location.country_code || ""
          )
            .trim()
            .toUpperCase(),

        state:
          String(
            location.region_code || ""
          )
            .trim()
            .toUpperCase(),

        city:
          String(location.city || "")
            .trim(),

        zip:
          String(location.postal || "")
            .trim()
      };
    })
    .catch(function (error) {
      window.clearTimeout(timeoutId);

      console.warn(
        "[DH Commerce] Anonymous location was not resolved:",
        error
      );

      return null;
    });
};


/*
  Resolves an anonymous visitor against the Near,
  Middle, and Far state lists supplied by Shopify.
*/

DHCommerce.shipping.resolveAnonymousVisitor = function () {
  return DHCommerce.shipping
    .getAnonymousLocation()
    .then(function (location) {
      if (
        !location ||
        location.country !== "US" ||
        !location.state
      ) {
        return null;
      }

      const resolution =
  DHCommerce.shipping.resolveTierFromState(
    location.state
  );

if (!resolution.matched) {
  return null;
}

DHCommerce.shipping.setLocation(location);

DHCommerce.shipping.saveLocationCache(
  resolution.tier,
  location
);

const payload =
  DHCommerce.shipping.setTier(
    resolution.tier,
    {
      source: "ip_state",
      confidence: "estimated",
      persist: true
    }
  );

payload.location =
  DHCommerce.state.shipping.location;

DHCommerce.emit(
  "shipping:location",
  {
    tier: resolution.tier,
    source: "ip_state",
    confidence: "estimated",
    location: location
  }
);

return payload;
});
};

DHCommerce.shipping.init = function () {

    if (DHCommerce.state.shipping.initialized) {

      return DHCommerce.state.shipping;

    }

    let tier = "unknown";

    let source = "default";

    let confidence = "unknown";

    /*
    Preview testing:

    Add one of these to the preview URL:

    ?dh_shipping=near
    ?dh_shipping=middle
    ?dh_shipping=far
    ?dh_shipping=unknown
    */

    const previewTier =
  DHCommerce.shipping.getPreviewOverride();

const sessionTier =
  DHCommerce.shipping.getSessionTier();

const locationCache =
  DHCommerce.shipping.getLocationCache();

const customerLocation =
  DHCommerce.shipping.getCustomerLocation();

const customerResolution =
  customerLocation.loggedIn &&
  customerLocation.state
    ? DHCommerce.shipping.resolveTierFromState(
        customerLocation.state
      )
    : null;

    if (previewTier) {

  tier = previewTier;

  source = "preview_override";

  confidence = "testing";

} else if (
  customerResolution &&
  customerResolution.matched
) {

  tier = customerResolution.tier;

  source = "shopify_customer_state";

  confidence = "verified_customer_address";

} else if (locationCache) {

  tier = locationCache.tier;

  source = "location_cache";

  confidence = "recent_ip_estimate";

  DHCommerce.shipping.setLocation(
    locationCache.location
  );

} else if (sessionTier) {

  tier = sessionTier;

  source = "session";

  confidence = "previously_assigned";

}

    DHCommerce.shipping.setTier(
      tier,
      {
        source: source,
        confidence: confidence,
        persist: source !== "preview_override"
      }
    );

    DHCommerce.state.shipping.initialized = true;

    const readyPayload = {

      tier:
        DHCommerce.state.shipping.tier,

      effectiveTier:
        DHCommerce.state.shipping.effectiveTier,

      source:
        DHCommerce.state.shipping.source,

      confidence:
        DHCommerce.state.shipping.confidence,

      rules:
        DHCommerce.shipping.getRules()

    };

    DHCommerce.emit(
      "shipping:ready",
      readyPayload
    );

/*
  Anonymous visitors receive the conservative fallback
  immediately, then update asynchronously when their
  state is successfully resolved.

  URL overrides and verified customer addresses remain
  higher priority.
*/

if (
  !previewTier &&
  !locationCache &&
  !sessionTier &&
  !(
    customerResolution &&
    customerResolution.matched
  )
) {
  DHCommerce.shipping.resolveAnonymousVisitor();
}

    return DHCommerce.state.shipping;

  };

    /* ======================================================
     PROMOTIONS
  ====================================================== */

  DHCommerce.promotions = {};

  /*
  Returns the complete promotion library.
  */

  DHCommerce.promotions.getLibrary = function () {

    return (
      DHCommerce.config.promotions &&
      DHCommerce.config.promotions.library
        ? DHCommerce.config.promotions.library
        : {}
    );

  };


  /*
  Returns the configured active promotion ID.
  */

  DHCommerce.promotions.getActivePromotionId = function () {

    return (
      DHCommerce.config.promotions &&
      DHCommerce.config.promotions.activePromotionId
        ? DHCommerce.config.promotions.activePromotionId
        : null
    );

  };


  /*
  Returns a promotion by ID.
  */

  DHCommerce.promotions.getById = function (promotionId) {

    if (!promotionId) {
      return null;
    }

    const library =
      DHCommerce.promotions.getLibrary();

    return library[promotionId] || null;

  };


  /*
  Determines whether a promotion is currently within its
  configured date window.

  Null start/end values mean there is no date restriction.
  */

  DHCommerce.promotions.isWithinSchedule = function (
    promotion,
    now
  ) {

    if (!promotion) {
      return false;
    }

    now = now instanceof Date
      ? now
      : new Date();

    const nowTime = now.getTime();

    if (promotion.startsAt) {

      const startTime =
        new Date(promotion.startsAt).getTime();

      if (
        !Number.isNaN(startTime) &&
        nowTime < startTime
      ) {

        return false;

      }

    }

    if (promotion.endsAt) {

      const endTime =
        new Date(promotion.endsAt).getTime();

      if (
        !Number.isNaN(endTime) &&
        nowTime > endTime
      ) {

        return false;

      }

    }

    return true;

  };


  /*
  Resolves the promotion experience for a shipping tier.

  This is the primary function homepage components will use.
  */

  DHCommerce.promotions.resolve = function (options) {

    options = options || {};

    const promotionId =
      options.promotionId ||
      DHCommerce.promotions.getActivePromotionId();

    const promotion =
      DHCommerce.promotions.getById(
        promotionId
      );

    if (
      !promotion ||
      promotion.active === false ||
      !DHCommerce.promotions.isWithinSchedule(
        promotion,
        options.now
      )
    ) {

      return null;

    }

    const requestedTier =
      DHCommerce.shipping.normalizeTier(
        options.tier ||
        DHCommerce.state.shipping.effectiveTier
      );

    const effectiveTier =
      DHCommerce.shipping.getEffectiveTier(
        requestedTier
      );

    const tierConfig =
      promotion.tiers &&
      promotion.tiers[effectiveTier]
        ? promotion.tiers[effectiveTier]
        : null;

    if (
      !tierConfig ||
      tierConfig.enabled === false
    ) {

      return null;

    }

    return {

      id: promotion.id,

      name: promotion.name || promotion.id,

      type: promotion.type || "general",

      priority: promotion.priority || 0,

      shippingTier: effectiveTier,

      eyebrow: tierConfig.eyebrow || "",

      headline: tierConfig.headline || "",

      message: tierConfig.message || "",

      offerLabel: tierConfig.offerLabel || "",

      freeShippingThreshold:
        Number(
          tierConfig.freeShippingThreshold
        ) || 0,

      giftThreshold:
        Number(
          tierConfig.giftThreshold
        ) || 0,

      giftName:
        tierConfig.giftName || "",

      ctaLabel:
        tierConfig.ctaLabel ||
        "Shop Now",

      startsAt:
        promotion.startsAt || null,

      endsAt:
        promotion.endsAt || null

    };

  };


  /*
  Returns the currently resolved promotion.
  */

  DHCommerce.promotions.getCurrent = function () {

    return DHCommerce.promotions.resolve();

  };


  /*
  Updates promotion unlock states based on a subtotal.
  The subtotal should be passed in dollars, not cents.
  */

  DHCommerce.promotions.evaluateCart = function (
    subtotal
  ) {

    subtotal = Number(subtotal) || 0;

    const promotion =
      DHCommerce.promotions.getCurrent();

    if (!promotion) {

      DHCommerce.state.promotions.active = [];

      DHCommerce.state.promotions.giftUnlocked =
        false;

      DHCommerce.state.promotions.freeShippingUnlocked =
        false;

      return null;

    }

    const freeShippingUnlocked =
      promotion.freeShippingThreshold > 0 &&
      subtotal >=
        promotion.freeShippingThreshold;

    const giftUnlocked =
      promotion.giftThreshold > 0 &&
      subtotal >=
        promotion.giftThreshold;

    DHCommerce.state.promotions.active = [
      promotion.id
    ];

    DHCommerce.state.promotions.freeShippingUnlocked =
      freeShippingUnlocked;

    DHCommerce.state.promotions.giftUnlocked =
      giftUnlocked;

    const payload = {

      promotion: promotion,

      subtotal: subtotal,

      freeShippingUnlocked:
        freeShippingUnlocked,

      giftUnlocked:
        giftUnlocked,

      amountUntilFreeShipping:
        promotion.freeShippingThreshold > 0
          ? Math.max(
              0,
              promotion.freeShippingThreshold -
              subtotal
            )
          : 0,

      amountUntilGift:
        promotion.giftThreshold > 0
          ? Math.max(
              0,
              promotion.giftThreshold -
              subtotal
            )
          : 0

    };

    DHCommerce.emit(
      "promotion:evaluated",
      payload
    );

    return payload;

  };


  /*
  Preserves the original helper for compatibility.
  */

  DHCommerce.promotions.unlockGift = function () {

    DHCommerce.state.promotions.giftUnlocked = true;

    DHCommerce.emit(
      "promotion:gift",
      {
        unlocked: true,
        promotion:
          DHCommerce.promotions.getCurrent()
      }
    );

  };


  /*
  Initializes the active promotion after shipping is ready.
  */

  DHCommerce.promotions.init = function () {

    const promotion =
      DHCommerce.promotions.getCurrent();

    DHCommerce.state.promotions.active =
      promotion
        ? [promotion.id]
        : [];

    DHCommerce.emit(
      "promotion:ready",
      {
        promotion: promotion,
        shipping:
          DHCommerce.state.shipping
      }
    );

    return promotion;

  };

  /* ======================================================
     ASSORTMENT
  ====================================================== */

  DHCommerce.assortment = {};

  DHCommerce.assortment.setSelections = function (items) {

    items = Array.isArray(items)
      ? items
      : [];

    DHCommerce.state.assortment.selections = items;

    DHCommerce.state.assortment.count = items.length;

    DHCommerce.emit(
      "assortment:updated",
      {
        count: items.length
      }
    );

  };

  /* ======================================================
     DASHBOARD
  ====================================================== */

  DHCommerce.dashboard = {};

  DHCommerce.dashboard.snapshot = function () {

    return JSON.parse(
      JSON.stringify(DHCommerce.state)
    );

  };

  /* ======================================================
     INIT
  ====================================================== */

  DHCommerce.init = function () {

    if (DHCommerce.state.initialized) {

      return;

    }

    DHCommerce.state.initialized = true;

    DHCommerce.emit(
      "framework:initialized",
      {
        version: DHCommerce.version
      }
    );

    DHCommerce.shipping.init();

    DHCommerce.promotions.init();

  };

  window.DHCommerce = DHCommerce;

  DHCommerce.init();

})(window, document);